export interface AuditColumnModel {
  _id?: string;
  metadata?: {
    modifiedBy: string;
    modifiedDate: string;
    createdBy: string;
    createdDate: string;
  }
}

export interface TenantModel {
  tenantDetails: {
    _id: string;
    name: string;
  }[];
}

export interface PaginationPayloadModel {
  limit: number;
  offset: number;
}

export interface PaginationModel {
  currentPage: number;
  endIndex: number;
  endPage: boolean;
  pages: number[];
  pageCount: number;
  startIndex: number;
  totalItems: number;
}

export interface StatusModel {
  type: string;
  title: string;
  colorCode: string;
  backgroundColorCode: string;
}

export interface ReportingIntervalModel {
  isRandom : boolean;
  min : number;
  max ?: number;
}
export interface MissingDataModel {
  status: boolean;
  percentage: number;
}

export interface ResponseModelV1<T> {
  data: T;
  message: string;
}

export interface ResponseModel<T> {
  message: string;
  data: T;
  pageInfo?: PaginationModel;
  status: boolean;
}

export interface ResponseModelV1<T> {
  data: T;
  pageInfo?: PaginationModel;
}

export const enum ActionType {
  VIEW = 'view',
  EDIT = 'edit',
  RESTORE = 'restore',
  DELETE = 'delete',
  ADD = 'add',
  COPY = 'copy',
  UPLOAD = 'upload',
  DOWNLOAD = 'download',
  STATS = 'stats',
  ATTACH = 'attach',
  DETACH = 'detach',
  CLONE = 'clone',
  VIEWPAYLOAD = 'viewPayload',
  ENABLEBATCH = 'enableBatch',
  BATCHREDIRECT = 'batchRedirect',
  BATCHACTIVITY = 'batchActivity',
  SIMULATIONSETTINGS = 'simulationSettings'
}

export enum State {
  WIP = 'star_half',
  RND = 'star_border',
  COMPLETED = ''
}

export enum Tab {
  HOST = 'Host',
  MODULES = 'Modules',
  PERIPHERALS = 'Peripherals'
}

export enum Status {
  ON = 'on',
  OFF = 'off',
  UNKNOWN = 'unknown'
}

export enum ViewType {
  TILE_VIEW = 'tile-view',
  LIST_VIEW = 'list-view',
  TREE_VIEW = 'tree-view',
  GRAPH_VIEW = 'graph-view'
}

export type StateType = State.WIP | State.RND | State.COMPLETED;

export interface TabList {
  label: Tab,
  type: Tab,
  utilisation: StatusModel;
  isActive: boolean
}
